export const sxRowStart = {
  display: "flex",
  flexDirection: "row",
  alignItems: "flex-start",
  justifyContent: "flex-start",
};

export const sxRowEnd = {
  display: "flex",
  flexDirection: "row",
  alignItems: "flex-end",
  justifyContent: "flex-end",
};

export const sxRowCenter = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
};

export const sxRowStretch = {
  display: "flex",
  flexDirection: "row",
  alignItems: "stretch",
  justifyContent: "stretch",
};

export const sxRowStartCenter = {
  display: "flex",
  flexDirection: "row",
  alignItems: "flex-start",
  justifyContent: "center",
};

export const sxRowStartEnd = {
  display: "flex",
  flexDirection: "row",
  alignItems: "flex-start",
  justifyContent: "flex-end",
};

export const sxRowStartBetween = {
  display: "flex",
  flexDirection: "row",
  alignItems: "flex-start",
  justifyContent: "space-between",
};

export const sxRowStartAround = {
  display: "flex",
  flexDirection: "row",
  alignItems: "flex-start",
  justifyContent: "space-around",
};

export const sxRowStartEvenly = {
  display: "flex",
  flexDirection: "row",
  alignItems: "flex-start",
  justifyContent: "space-evenly",
};

export const sxRowCenterStart = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "flex-start",
};

export const sxRowCenterEnd = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "flex-end",
};

export const sxRowCenterBetween = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
};

export const sxRowCenterAround = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-around",
};

export const sxRowCenterEvenly = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-evenly",
};

export const sxColumnStart = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "flex-start",
};

export const sxColumnEnd = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-end",
  justifyContent: "flex-end",
};

export const sxColumnCenter = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
};

export const sxColumnStretch = {
  display: "flex",
  flexDirection: "column",
  alignItems: "stretch",
  justifyContent: "stretch",
};

export const sxColumnStartCenter = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "center",
};

export const sxColumnStartEnd = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "flex-end",
};

export const sxColumnStartBetween = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "space-between",
};

export const sxColumnStartAround = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "space-around",
};

export const sxColumnStartEvenly = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "space-evenly",
};

export const sxColumnCenterStart = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "flex-start",
};

export const sxColumnCenterEnd = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "flex-end",
};

export const sxColumnCenterBetween = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "space-between",
};

export const sxColumnCenterAround = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "space-around",
};

export const sxColumnCenterEvenly = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "space-evenly",
};

// Text
export const sxText1230016 = {
  fontSize: "12px",
  fontWeight: 300,
  lineHeight: "16px",
};

export const sxText1240016 = {
  fontSize: "12px",
  fontWeight: 400,
  lineHeight: "16px",
};

export const sxText1250016 = {
  fontSize: "12px",
  fontWeight: 500,
  lineHeight: "16px",
};

export const sxText1430020 = {
  fontSize: "14px",
  fontWeight: 300,
  lineHeight: "20px",
};

export const sxText1440020 = {
  fontSize: "14px",
  fontWeight: 400,
  lineHeight: "20px",
};

export const sxText1450020 = {
  fontSize: "14px",
  fontWeight: 500,
  lineHeight: "20px",
};

export const sxText1460020 = {
  fontSize: "14px",
  fontWeight: 600,
  lineHeight: "20px",
};

export const sxText1630024 = {
  fontSize: "16px",
  fontWeight: 300,
  lineHeight: "24px",
};

export const sxText1640024 = {
  fontSize: "16px",
  fontWeight: 400,
  lineHeight: "24px",
};

export const sxText1650024 = {
  fontSize: "16px",
  fontWeight: 500,
  lineHeight: "24px",
};

export const sxText1660024 = {
  fontSize: "16px",
  fontWeight: 600,
  lineHeight: "24px",
};

export const sxText1860028 = {
  fontSize: "18px",
  fontWeight: 600,
  lineHeight: "28px",
};

export const sxText2460032 = {
  fontSize: "24px",
  fontWeight: 600,
  lineHeight: "32px",
};

export const sxText3070036 = {
  fontSize: "30px",
  fontWeight: 700,
  lineHeight: "36px",
};

export const sxText4850048 = {
  fontSize: "48px",
  fontWeight: 500,
  lineHeight: "48px",
};

// style
export const sxDot = {
  width: '4px',
  height: '4px',
  backgroundColor: 'rgba(217, 217, 217, 1)',
  borderRadius: '50%',
}
